import React, { Component } from "react";
import styled from "styled-components";
import { observable } from "mobx";
import { observer } from "mobx-react";
import List from "./ListWithQuery";
import AddFieldModal from "./AddFieldModalWithMutation";
import Panel from "../common/Panel";
import AddButtonRaw from "../common/AddButton";

export default observer(
  class CustomerFieldPanel extends Component {
    states = observable({ showModal: false });

    render() {
      const showModal = this.states.showModal;
      return (
        <Panel title="CUSTOMER FIELD">
          <AddButton onClick={this.showModal}>+ Add New Field</AddButton>
          <List />
          {showModal && (
            <AddFieldModal
              onCancel={this.hideModal}
              onConfirm={this.hideModal}
            />
          )}
        </Panel>
      );
    }

    hideModal = () => {
      this.states.showModal = false;
    };

    showModal = () => {
      this.states.showModal = true;
    };
  }
);

const AddButton = styled(AddButtonRaw)`
  margin-top: 10px;
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/customer-field-panel/CustomerFieldPanel.js